const PurpleButton = ({label, width, margin, onClick}) => {
    return (
        <button type="button" className="button purple-button" style={{minWidth: width ? width : null, margin: margin ? margin : null}} onClick={onClick}>{label}</button>
    );
}

export default PurpleButton;